import { IExcelField,  TCMResponseDataService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { ResultData } from "@nt-portal/common-sdk";

export interface TCMScheduleColumnOptions extends ControllerOptions<IExcelField> {
    scheduleId?: string;
    sheetId?: string;
}

export const initExcelField = () => {
    let item: IExcelField = {
        name: "",
        width: 0,
        visible: false,
        excelHeading: "",
        dataType: ""
    }
    return item;
}


export class ClientTCMScheduleColumnsService extends BaseClientService {

    private _service: TCMResponseDataService;


    constructor() {
        super();
        this._service = new TCMResponseDataService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: TCMScheduleColumnOptions): Promise<IExcelField[]> {

        if (options.scheduleId && options.sheetId) {
            this._service.params.scheduleId = options.scheduleId;
            return await this._service.getColumns(this.token, options.sheetId);
        } else {
            throw new Error("Schedule ID and Sheet Id is required to get columns");
        }

    }

    public async update(options: TCMScheduleColumnOptions): Promise<IExcelField[] | null> {
        if (options.items && options.scheduleId && options.sheetId) {
            this._service.params.scheduleId = options.scheduleId;
            return await this._service.saveColumns(this.token, options.items as IExcelField[], options.sheetId)
        }
        return null;
    }

}